import { Paragraph, TextRun, HeadingLevel, AlignmentType } from 'docx'
import { ProcessingContext } from '../types'

/**
 * Process heading lines and return paragraph or null
 */
export function processHeading(
  trimmedLine: string,
  context: ProcessingContext
): Paragraph | null {
  if (trimmedLine.startsWith('#')) {
    const headerMatch = trimmedLine.match(/^(#{1,6})\s+(.+)/)
    if (headerMatch) {
      const level = headerMatch[1].length
      const text = headerMatch[2].trim()
      
      let headingLevel: HeadingLevel
      let fontSize: number
      
      switch (level) {
        case 1:
          headingLevel = HeadingLevel.HEADING_1
          fontSize = context.nameFontSize
          break
        case 2:
          headingLevel = HeadingLevel.HEADING_2
          fontSize = context.headerFontSize
          break
        case 3:
          headingLevel = HeadingLevel.HEADING_3
          fontSize = context.headerFontSize - 2
          break
        case 4:
          headingLevel = HeadingLevel.HEADING_4
          fontSize = context.headerFontSize - 4
          break
        case 5:
          headingLevel = HeadingLevel.HEADING_5
          fontSize = context.headerFontSize - 6
          break
        case 6:
          headingLevel = HeadingLevel.HEADING_6
          fontSize = context.headerFontSize - 8
          break
        default:
          headingLevel = HeadingLevel.HEADING_1
          fontSize = context.nameFontSize
      }
      
      return new Paragraph({
        children: [new TextRun({ 
          text: text, 
          bold: true, 
          size: fontSize,
          font: context.font,
          color: '000000'
        })],
        heading: headingLevel,
        alignment: AlignmentType.LEFT,
        spacing: { 
          before: level === 1 ? 0 : 240, 
          after: level === 1 ? 120 : 120 
        }
      })
    }
  }
  return null
}